/**
 * Profile utilities for Poker Reborn
 *
 * Decodes profile data from ACC responses.
 * Format: nested JSON object (server always sends plain JSON).
 */

/**
 * Decode profile data into a JSON object.
 *
 * Accepts an object (current format) or a JSON string.
 *
 * @returns Decoded object, or undefined if input is invalid or unparseable
 */
export function decodeProfile(raw: unknown): Record<string, unknown> | undefined {
  if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) {
    return raw as Record<string, unknown>;
  }

  if (typeof raw !== 'string' || raw.length === 0) return undefined;

  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return undefined;
  }
}
